import { render, staticRenderFns } from "./network-matriz.vue?vue&type=template&id=a18ffde8"
import script from "./network-matriz.vue?vue&type=script&lang=js"
export * from "./network-matriz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports